export const CHECKOUT_TOKEN = 'checkout-token';
export const SESSION_ID = 'session-id';
export const PUBLISHER_TOKEN = 'publisher-token';
